import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import afe0858d03aa7c7d3dc50fb4aff721f2fb from "./generated-587fa174-fece-4ce8-bc0a-9e04f66c3b8b.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/bookmaker-settings"){
            
                    await direct(afe0858d03aa7c7d3dc50fb4aff721f2fb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */